export interface TrendItem {
  id: number;
  cat: string;
  title: string;
  heat: string;
  dir: 'up' | 'down' | 'flat';
  delta: string;
  tag: string;
  series: number[];
}

export const CATEGORIES = [
  { key: 'all', label: '全站', icon: 'ri-fire-line' },
  { key: 'ent', label: '娱乐', icon: 'ri-star-smile-line' },
  { key: 'social', label: '社会', icon: 'ri-earth-line' },
  { key: 'sports', label: '体育', icon: 'ri-trophy-line' },
  { key: 'finance', label: '财经', icon: 'ri-line-chart-line' },
  { key: 'tech', label: '科技', icon: 'ri-cpu-line' },
];

export const TRENDS: TrendItem[] = [
  { id: 1, cat: 'ent', title: '新一季音综导师阵容官宣 引爆全网讨论', heat: '1386万', dir: 'up', delta: '+182%', tag: '热搜爆', series: [4, 6, 9, 14, 22, 36, 58, 88] },
  { id: 2, cat: 'social', title: '多城上线便民夜间地铁 通勤族点赞', heat: '1120万', dir: 'up', delta: '+146%', tag: '热议', series: [3, 5, 8, 12, 18, 30, 47, 72] },
  { id: 3, cat: 'ent', title: '年代剧杀青路透刷屏 服化道细节获好评', heat: '986万', dir: 'flat', delta: '+8%', tag: '关注', series: [20, 24, 27, 29, 30, 31, 30, 33] },
  { id: 4, cat: 'sports', title: '男篮世预赛关键战 读秒三分绝杀逆转', heat: '1042万', dir: 'up', delta: '+210%', tag: '爆瓜', series: [2, 3, 5, 8, 13, 24, 45, 79] },
  { id: 5, cat: 'finance', title: '多家车企发布新款纯电 SUV 价格战再起', heat: '820万', dir: 'up', delta: '+96%', tag: '热议', series: [6, 8, 10, 14, 20, 27, 38, 52] },
  { id: 6, cat: 'tech', title: '端侧大模型新品亮相 手机 AI 离线可用', heat: '754万', dir: 'up', delta: '+74%', tag: '热榜', series: [5, 7, 9, 13, 16, 24, 35, 46] },
  { id: 7, cat: 'social', title: '菜市场改造后颜值翻倍 烟火气不散', heat: '610万', dir: 'flat', delta: '+12%', tag: '关注', series: [14, 16, 18, 19, 22, 25, 27, 30] },
  { id: 8, cat: 'ent', title: '演唱会黄牛乱象引热议 平台重拳整治', heat: '1330万', dir: 'up', delta: '+168%', tag: '爆瓜', series: [7, 9, 12, 18, 27, 41, 63, 90] },
  { id: 9, cat: 'sports', title: '马拉松大众组跑出惊人成绩 网友致敬', heat: '488万', dir: 'down', delta: '-23%', tag: '热议', series: [60, 55, 50, 46, 42, 40, 38, 33] },
  { id: 10, cat: 'tech', title: '折叠屏轻薄化竞赛 各家旗舰轮番上新', heat: '692万', dir: 'up', delta: '+58%', tag: '热榜', series: [8, 9, 12, 15, 19, 26, 33, 41] },
  { id: 11, cat: 'finance', title: '文旅消费券上新 周边游预订明显回暖', heat: '540万', dir: 'up', delta: '+42%', tag: '关注', series: [9, 11, 13, 16, 20, 26, 31, 36] },
  { id: 12, cat: 'ent', title: '短剧春节档备案名单公布 题材百花齐放', heat: '398万', dir: 'down', delta: '-11%', tag: '行业', series: [34, 32, 30, 29, 27, 26, 25, 24] },
  { id: 13, cat: 'social', title: '宠物友好商场走红 周末遛宠成新潮流', heat: '786万', dir: 'up', delta: '+121%', tag: '热议', series: [4, 5, 8, 12, 19, 28, 44, 63] },
  { id: 14, cat: 'sports', title: '乒乓球国手积分再登顶 巴黎周期备战', heat: '452万', dir: 'up', delta: '+33%', tag: '关注', series: [12, 13, 15, 18, 22, 27, 31, 35] },
  { id: 15, cat: 'tech', title: '低空经济试点扩容 无人机配送提速', heat: '734万', dir: 'up', delta: '+89%', tag: '热榜', series: [5, 8, 11, 15, 21, 30, 42, 57] },
  { id: 16, cat: 'finance', title: '新一批国产新药获批上市 创新药升温', heat: '666万', dir: 'up', delta: '+67%', tag: '热议', series: [6, 8, 11, 15, 22, 29, 40, 51] },
  { id: 17, cat: 'social', title: 'citywalk 街区改造出圈 主理人小店扎堆', heat: '580万', dir: 'flat', delta: '+15%', tag: '关注', series: [16, 18, 20, 23, 25, 28, 30, 33] },
  { id: 18, cat: 'ent', title: '老牌主持人复出带货 怀旧情怀被点燃', heat: '471万', dir: 'up', delta: '+51%', tag: '行业', series: [8, 10, 14, 18, 24, 31, 40, 50] },
];

export const RISING = [
  { id: 1, title: '读秒绝杀刷屏 体育话题单小时暴涨', rise: '+312%', heat: '1042万' },
  { id: 2, title: '演唱会整治黄牛 平台连夜升级规则', rise: '+268%', heat: '1330万' },
  { id: 3, title: '新音综导师官宣 全网考古名场面', rise: '+214%', heat: '1386万' },
  { id: 4, title: '宠物友好商场 周末排队出圈', rise: '+176%', heat: '786万' },
  { id: 5, title: '夜间便民地铁 打工人疯狂点赞', rise: '+149%', heat: '1120万' },
  { id: 6, title: '无人机配送试点 一公里外投递成功', rise: '+121%', heat: '734万' },
];

export const STATS = [
  { label: '今日上榜话题', value: '1286', unit: '条' },
  { label: '站内实时更新', value: '3', unit: '秒' },
  { label: '覆盖热榜来源', value: '32', unit: '个' },
  { label: '爆瓜预警触发', value: '17', unit: '次' },
];

export const CATEGORY_CARDS = [
  { key: 'ent', name: '娱乐八卦', icon: 'ri-star-smile-line', desc: '剧综、唱跳、绯闻与幕后，第一时间递上热瓜。', hot: '新音综导师官宣', follow: '386万人在看' },
  { key: 'social', name: '社会民生', icon: 'ri-earth-line', desc: '城市新鲜事与民生动态，看懂身边正在发生什么。', hot: '夜间便民地铁上线', follow: '212万人在看' },
  { key: 'sports', name: '体育赛事', icon: 'ri-trophy-line', desc: '绝杀、爆冷与破纪录，赛场热度曲线实时追踪。', hot: '男篮读秒绝杀', follow: '298万人在看' },
  { key: 'finance', name: '财经消费', icon: 'ri-line-chart-line', desc: '车企价格战与消费趋势，热点背后的商业逻辑。', hot: '车企纯电价格战', follow: '156万人在看' },
  { key: 'tech', name: '科技数码', icon: 'ri-cpu-line', desc: '端侧 AI、折叠屏与低空经济，前沿动态不错过。', hot: '手机端侧大模型', follow: '188万人在看' },
];

export const EDITORIAL = [
  {
    id: 'e1',
    kicker: '爆瓜深度',
    title: '从热搜词到舆论场：一场"绝杀"如何一夜刷屏',
    lead: '体育赛场的一记读秒三分，为何能同时点燃虎扑弹幕、短视频二创与早高峰地铁里的谈资？我们把这条热度曲线拆开来看。',
    points: [
      '第一波：赛后 8 分钟，解说名场面切片开始在各个群流转，播放量破百万。',
      '第二波：营销号跟进"看球名场面"，情绪化的二创迅速扩散至大众圈层。',
      '第三波：主流媒体与球迷文化号深度复盘，话题进入长尾讨论期。',
      '规律：凡是从专业圈"出圈"到大众圈的话题，往往伴随强情绪点与二次创作素材。',
    ],
  },
  {
    id: 'e2',
    kicker: '行业观察',
    title: '演唱会黄牛为何越治越"野"？平台整治全解析',
    lead: '演出市场回暖的同时，黄牛技术也在升级。这次多平台联合出手，重点究竟打在哪儿？',
    points: [
      '演出票务的难点在于信息不对称，热门场次供需极度失衡。',
      '本次整治覆盖异常抢票设备、转票抬价与实名入场三个环节。',
      '专家建议结合强实名与退票通道，让真正想看的人能买到票。',
    ],
  },
  {
    id: 'e3',
    kicker: '趋势前瞻',
    title: '端侧大模型落地：手机里的 AI 要"断网可用"',
    lead: '多家厂商同日发布端侧大模型能力，离线也能对话、修图、总结文档。这对普通用户意味着什么？',
    points: [
      '端侧模型把推理放在本机，响应更快、隐私更好、无需网络。',
      '对芯片算力与内存要求更高，中端机型成普及关键变量。',
      '行业普遍认为，2026 年将是端侧 AI 从"能跑"走向"好用"的一年。',
    ],
  },
];

export const FAQS = [
  { q: '快瓜的热榜数据从哪来？多久更新一次？', a: '我们聚合多路公开热榜与话题检索信号，站内榜单每 3 秒自动刷新一次，同时保留当日热度曲线，方便你回看话题的升温全过程。当前展示为演示样例数据。' },
  { q: '"爆瓜预警"是什么意思？', a: '当某个话题在短时间内热度增长超过阈值、具备"爆发"特征时，系统会触发爆瓜预警并置顶展示，帮你第一时间抓住正在飙升的舆论热点。' },
  { q: '为什么同一个话题在不同榜单里热度不一样？', a: '不同来源的榜单算法、统计口径和覆盖人群不同，热度数值存在差异是正常的。我们以"多源信号综合热度"为准，并给出涨跌幅度供你参考。' },
  { q: '我可以只看某一类话题吗？', a: '可以。热榜支持按娱乐、社会、体育、财经、科技等分类切换；订阅瓜讯后，未来还可按兴趣分组推送你最关心的话题风向。' },
  { q: '快瓜的内容有立场吗？吃瓜如何保持清醒？', a: '我们只做信息的聚合与曲线呈现，不做情绪化站队。建议你在多个信源交叉验证后再下结论，先让子弹飞一会儿，瓜才吃得明白。' },
];

export const FOOTER_LINKS = [
  { group: '板块导航', items: ['实时热榜', '上升最快', '瓜田分类', '深度吃瓜'] },
  { group: '常见问题', items: ['数据来源', '爆瓜预警', '热度口径', '分类订阅'] },
  { group: '关于快瓜', items: ['品牌介绍', '内容原则', '用户口碑', '联系我们'] },
];